var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronLeftEnd = function SvgChevronLeftEnd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5856 7.46855C17.8444 7.1451 17.7919 6.67313 17.4685 6.41438C17.145 6.15562 16.6731 6.20806 16.4143 6.53151L12.4143 11.5315C12.1952 11.8054 12.1952 12.1946 12.4143 12.4685L16.4143 17.4685C16.6731 17.792 17.145 17.8444 17.4685 17.5857C17.7919 17.3269 17.8444 16.855 17.5856 16.5315L13.9604 12L17.5856 7.46855ZM11.5856 7.46855C11.8444 7.1451 11.7919 6.67313 11.4685 6.41438C11.145 6.15562 10.6731 6.20806 10.4143 6.53151L6.41432 11.5315C6.19519 11.8054 6.19519 12.1946 6.41432 12.4685L10.4143 17.4685C10.6731 17.792 11.145 17.8444 11.4685 17.5857C11.7919 17.3269 11.8444 16.855 11.5856 16.5315L7.96044 12L11.5856 7.46855Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeftEnd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chevron-left-end.027f5a21748584a40aaca03fb31b1a40.svg";